export const NAMESPACE = 'conflicts_listing';
